import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classPrivateFieldGet from "@babel/runtime/helpers/classPrivateFieldGet";
import _classPrivateFieldSet from "@babel/runtime/helpers/classPrivateFieldSet";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }

import { gosNREUMOriginals } from '../../../common/window/nreum';
import { isBrowserScope } from '../../../common/constants/runtime';

var _evaluated = /*#__PURE__*/new WeakMap();

var _brokenSheets = /*#__PURE__*/new WeakMap();

var _fetchAndOverride = /*#__PURE__*/new WeakSet();

var StylesheetEvaluator = /*#__PURE__*/function () {
  function StylesheetEvaluator() {
    _classCallCheck(this, StylesheetEvaluator);

    _fetchAndOverride.add(this);

    _evaluated.set(this, {
      writable: true,
      value: new WeakSet()
    });

    _brokenSheets.set(this, {
      writable: true,
      value: []
    });

    _defineProperty(this, "invalidStylesheetsDetected", false);

    _defineProperty(this, "failedToFix", 0);
  }
  /**
  * Flipped to true if stylesheets that cannot be natively inlined are detected by the stylesheetEvaluator class
  * Used at harvest time to denote that all subsequent payloads are subject to this and customers should be advised to handle crossorigin decoration
  * */


  _createClass(StylesheetEvaluator, [{
    key: "evaluate",
    value:
    /**
     * this works by checking (only ever once) each cssRules obj in the style sheets array. The try/catch will catch an error if the cssRules obj blocks access, triggering the module to try to "fix" the asset`. Returns the count of incomplete assets discovered.
     * @returns {Number}
     */
    function evaluate() {
      var incompletes = 0;

      _classPrivateFieldSet(this, _brokenSheets, []);

      if (isBrowserScope) {
        for (var i = 0; i < Object.keys(document.styleSheets).length; i++) {
          if (!_classPrivateFieldGet(this, _evaluated).has(document.styleSheets[i])) {
            _classPrivateFieldGet(this, _evaluated).add(document.styleSheets[i]);

            try {
              // eslint-disable-next-line
              var temp = document.styleSheets[i].cssRules;
            } catch (err) {
              if (!document.styleSheets[i].href) return;
              incompletes++;

              _classPrivateFieldGet(this, _brokenSheets).push(document.styleSheets[i]);
            }
          }
        }
      }

      if (incompletes) this.invalidStylesheetsDetected = true;
      return incompletes;
    }
    /**
     * Resolves promise once all stylesheets have been fetched and overridden
     * @returns {Promise}
     */

  }, {
    key: "fix",
    value: function () {
      var _fix = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this = this;

        var failedToFix;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Promise.all(_classPrivateFieldGet(this, _brokenSheets).map(function (sheet) {
                  return _classPrivateMethodGet(_this, _fetchAndOverride, _fetchAndOverride2).call(_this, sheet);
                }));

              case 2:
                _classPrivateFieldSet(this, _brokenSheets, []);

                failedToFix = this.failedToFix;
                this.failedToFix = 0;
                return _context.abrupt("return", failedToFix);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fix() {
        return _fix.apply(this, arguments);
      }

      return fix;
    }()
    /**
    * Fetches stylesheet contents and overrides the target getters
    * @param {*} target - The stylesheet object target - ex. document.styleSheets[0]
    * @param {*} href - The asset href to fetch
    * @returns {Promise}
    */

  }]);

  return StylesheetEvaluator;
}();

function _fetchAndOverride2(_x) {
  return _fetchAndOverride3.apply(this, arguments);
}

function _fetchAndOverride3() {
  _fetchAndOverride3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(target) {
    var stylesheetContents, stylesheetText, cssSheet;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (target !== null && target !== void 0 && target.href) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt("return");

          case 2:
            _context2.prev = 2;
            _context2.next = 5;
            return gosNREUMOriginals().o.FETCH.bind(window)(target.href);

          case 5:
            stylesheetContents = _context2.sent;

            if (stylesheetContents.ok) {
              _context2.next = 9;
              break;
            }

            this.failedToFix++;
            return _context2.abrupt("return");

          case 9:
            _context2.next = 11;
            return stylesheetContents.text();

          case 11:
            stylesheetText = _context2.sent;
            _context2.prev = 12;
            cssSheet = new CSSStyleSheet();
            _context2.next = 16;
            return cssSheet.replace(stylesheetText);

          case 16:
            Object.defineProperty(target, 'cssRules', {
              get: function get() {
                return cssSheet.cssRules;
              }
            });
            Object.defineProperty(target, 'rules', {
              get: function get() {
                return cssSheet.rules;
              }
            });
            _context2.next = 24;
            break;

          case 20:
            _context2.prev = 20;
            _context2.t0 = _context2["catch"](12);
            // cant make new dynamic stylesheets, browser likely doesn't support `.replace()`...
            // this is appended in prep of forking rrweb
            Object.defineProperty(target, 'cssText', {
              get: function get() {
                return stylesheetText;
              }
            });
            this.failedToFix++;

          case 24:
            _context2.next = 29;
            break;

          case 26:
            _context2.prev = 26;
            _context2.t1 = _context2["catch"](2);
            // failed to fetch
            this.failedToFix++;

          case 29:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this, [[2, 26], [12, 20]]);
  }));
  return _fetchAndOverride3.apply(this, arguments);
}

export var stylesheetEvaluator = new StylesheetEvaluator();